import { HostingOnboardingSteps } from '@constants/routes'

export const STARTING_SCREEN_V2: HostingOnboardingSteps = 'listing-type'

export const FIRST_SCREEN_AFTER_CREATING_LISTING_V2: HostingOnboardingSteps =
  'basics-preview'
